import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import PosterDefault from '../../../../shared/assets/images/png/posterDefault.png';
import Screen from '../../../../shared/utils/screen';
import DeviceConfig from '@devices/config';

interface Props {
  height: number;
  width: number;
  src: string;
}

const VerticalCardImage = styled.img<Props>`
  border-radius: ${20 * Screen.widthRatio}px;
  position: relative;
  left: ${1 * Screen.widthRatio}px;
  height: ${350 * Screen.widthRatio}px;
  width: ${235 * Screen.widthRatio}px;
  top: ${1 * Screen.widthRatio}px;
  ${() => {
    return DeviceConfig.capabilities?.image?.disableFitCover
      ? ''
      : 'object-fit:cover';
  }};
`;

VerticalCardImage.defaultProps = {
  src: PosterDefault,
};

export default withImage(VerticalCardImage, true, PosterDefault);
